
class NotifyMe extends HTMLElement {
    constructor() {
        super();

        this.productId = this.dataset.id;
        if (!this.productId) return;

        this.selectors = this.selectors || {};
        this.selectors.form = this.querySelector("form");
        this.selectors.notifyModal = this.querySelector("[data-notify-me-modal]");
        this.selectors.email = this.querySelector('input[name="notify-email"]');
        this.selectors.productSKU = this.querySelector('input[name="notify-sku"]');
        this.selectors.alertCode = this.querySelector('input[name="notify-sku"]');
        
        this.selectors.notifyOpenBtn = this.querySelector("[data-notify-modal-open]");
        this.selectors.notifyCloseBtn = this.querySelector("[data-notify-modal-close]");
        this.selectors.notifySuccessMsg = this.querySelector("[data-notify-success-msg]");
        this.selectors.notifyProductGrid = this.closest("[data-product-id]");

        this.selectors.notifyOpenBtn.addEventListener("click", this.show.bind(this));
        this.selectors.notifyCloseBtn.addEventListener("click", this.hide.bind(this));
        this.selectors.form?.addEventListener("submit", this.submit.bind(this));
    }

    show() {
        this.selectors.notifyModal.style.display = "block";
        this.selectors.notifyProductGrid?.classList.remove('sold_out_item');
        document.querySelector('body').style.overflow = "hidden";
        _theme.focusTrap($(this.selectors.notifyModal), () => {
            this.hide();
        });
    }

    hide() {
        this.selectors.notifyModal.style.display = "none";
        this.selectors.notifyProductGrid.classList.add('sold_out_item');
        document.querySelector('body').style.overflow = "";
        this.reset();
        this.selectors.notifyOpenBtn.focus();
    }

    submit(event) {
        event.preventDefault();

        const emailAddress = this.selectors.email.value.trim();
        const productSKU = this.selectors.productSKU.value.trim();
        const alertCode = this.selectors.alertCode.value.trim();

        const isValid = _theme.Helpers.validateEmail(emailAddress);
        const errorElem = this.querySelector(".input-error");
        errorElem.classList.add("hidden");

        if (isValid) {
            this.submitDetails(emailAddress, productSKU, alertCode);
            this.showSuccessMsg();
            setTimeout(this.hide.bind(this), 3000);
        } else {
            this.selectors.email.focus();
            errorElem.classList.remove("hidden");
        }
    }

    submitDetails(emailAddress, productSKU, alertCode) {
        if (!window._ltk) return false;
        if (!emailAddress || !productSKU || !alertCode) return false;

        _ltk.Alerts.AddAlertWithIdentifiers({Identifiers:{Email:emailAddress}, Sku:productSKU, AlertCode:alertCode});
        _ltk.Alerts.Submit();
        _theme.track.trackData({'event': 'notifyMeFormSubmitted'});

        return true;
    }

    showSuccessMsg() {
        this.selectors.notifyModal.querySelector('.notify-modal-header').classList.add('hidden');
        this.selectors.notifyModal.querySelector('.notify-modal-footer').classList.add('hidden');
        this.selectors.form.classList.add('hidden');
        this.selectors.notifySuccessMsg.classList.remove("hidden");
    }

    reset() {
        this.selectors.notifyModal.querySelector('.notify-modal-header').classList.remove('hidden');
        this.selectors.notifyModal.querySelector('.notify-modal-footer').classList.remove('hidden');
        this.selectors.form.classList.remove('hidden');
        this.selectors.notifySuccessMsg.classList.add("hidden");
        this.selectors.email.value = '';
    }

}
customElements.define("notify-me", NotifyMe);